/**
 * 权重
 */

import { InputNumber, Tooltip } from 'antd'
import classNames from 'classnames'
import styles from '../AiForm.module.css'
import { PrimitiveAtom, useAtom } from 'jotai'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { MySlider } from '~/components/ui/MySlider'

interface Props {
  label: string
  atom: PrimitiveAtom<any>
  disabled?: boolean
  step?: number
  min?: number
  max?: number
  digits?: number
  helpContent?: string
}

export const SliderInput: React.FC<Props> = ({
  label,
  atom,
  disabled = false,
  step = 1,
  min = 0,
  max = 65535,
  digits = 0,
  helpContent,
}) => {
  const [v, setV] = useAtom(atom)

  return (
    <div className="flex items-center mb-3">
      <span className={classNames('text-neutral-500 w-[120px]')}>
        {label}{' '}
        <Tooltip placement="topLeft" arrowPointAtCenter title={helpContent}>
          <QuestionCircleOutlined />
        </Tooltip>
      </span>
      <MySlider
        className="flex-1"
        step={step}
        min={min}
        max={max}
        value={v}
        onChange={val => {
          setV(val)
        }}
        tooltip={{ formatter: null }}
        disabled={disabled}
      />
      <InputNumber
        min={min}
        max={max}
        className={styles.inputNumber}
        value={v}
        onChange={val => {
          setV(Number(val?.toFixed(digits)))
        }}
        disabled={disabled}
      />
    </div>
  )
}

export function createSliderInputComponent(props: Props, displayName?: string) {
  const Comp = (overrideProps: Partial<Props>) => (
    <SliderInput {...props} {...overrideProps} />
  )
  Comp.displayName = displayName || 'SliderInput'

  return Comp
}
